import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getDataSpedNormative as getDataSpedNormativeApi,
	getDataSpedRestrictionsByNMBahia as getDataSpedRestrictionsByNMBahiaApi,
	getConcession as getConcessionApi,
	getRisksMaster as getRisksMasterApi
} from '../../helpers/data_sped/backend_helper';

export const getDataSpedNormative = createAsyncThunk('spedData/getDataSpedNormative', async (bcn_code) => {
	try {
		const response = getDataSpedNormativeApi(bcn_code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getDataSpedRestrictionsByNMBahia = createAsyncThunk('spedData/getDataSpedRestrictionsByNMBahia', async (nmbahia_id) => {
	try {
		const response = getDataSpedRestrictionsByNMBahiaApi(nmbahia_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});



export const getDataSpedRestrictionsByNMCapitania = createAsyncThunk('spedData/getDataSpedRestrictionsByNMCapitania', async (nmcapitania_id) => {
	try {
		const response = getDataSpedRestrictionsByNMCapitaniaApi(nmcapitania_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getConcession = createAsyncThunk('spedData/getConcession', async (code_siep) => {
	try {
		const response = getConcessionApi(code_siep);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getRisksMaster = createAsyncThunk('spedData/getRisksMaster', async () => {
	try {
		const response = getRisksMasterApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

